import React, { useEffect, useState } from "react";
import { useRouter } from "next/compat/router";

export const PageLoadingIndicator = () => {
  const router = useRouter();
  const { events } = router || {};

  const [isVisible, setIsVisible] = useState(false);

  const finished = () => {
    setIsVisible(false);
  };

  const routeChangeStart = () => {
    setIsVisible(true);
  };

  useEffect(() => {
    events?.on("routeChangeStart", routeChangeStart);
    events?.on("routeChangeComplete", finished);
    events?.on("routeChangeError", finished);
    return () => {
      events?.off("routeChangeStart", routeChangeStart);
      events?.off("routeChangeComplete", finished);
      events?.off("routeChangeError", finished);
    };
  }, [events]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 100000,
        height: 4,
        width: isVisible ? "100%" : "0px",
        backgroundColor: "var(--clr-secondary, #e60079)",
        transition: isVisible ? "width 8s cubic-bezier(0, 0, 0.2, 1) 0.2s" : "",
      }}
    />
  );
};

export default PageLoadingIndicator;
